import { DefaultTheme } from 'styled-components';
import { Button, ButtonSize } from 'components/elements';
import { css, styled } from 'styles';

const normalStyle = css`
  height: ${({ theme }) => theme.element.height}px;
  width: ${({ theme }) => theme.element.height}px;
`;

const smallStyle = css`
  height: 2rem;
  width: 2rem;
`;

const getSizeStyle = (theme: DefaultTheme, size?: ButtonSize) => {
  switch (size) {
    case 'small':
      return smallStyle;
    case 'normal':
    default:
      return normalStyle;
  }
};

export const StyledIconButton = styled(Button)`
  padding: 0;

  ${({ size, theme }) => getSizeStyle(theme, size)};
`;

StyledIconButton.displayName = 'IconButton.Styled';
